<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							Edit Request Enrollment
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="studentCode" class="col-form-label">Student Code</label>
									<div class="input-group">
										<input type="text" v-model="student_code" @blur="validationRule()" class="form-control" id="studentCode" readonly>
									</div>
								</div>
								<div class="col-md-6">
									<label for="studentName" class="col-form-label">Student Name</label>
									<input type="text" v-model="student_name" @blur="validationRule()" class="form-control" id="studentName" readonly>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="batchCode" class="col-form-label">Batch Code <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.batch_id" @blur="validationRule()" class="form-control" id="batchCode" @change="getFeeCode()">
										<option value="">Select Batch Code</option>
										<option v-for="batch in batchCodeList" :key="batch.id" :value="batch.id">{{ batch.code1}} {{ batch.code2 }} {{ batch.code3 }}</option>
									</select>
									<small class="text-danger">{{validationData.batch_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="feeCode" class="col-form-label">Fee Code <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.fee_id" @blur="validationRule()" class="form-control" id="feeCode" @change="getTerm()">
										<option value="">Select Fee Code</option>
										<option v-for="fee in feeCodeList" :key="fee.id" :value="fee.id">{{ fee.code }}</option>
									</select>
									<small class="text-danger">{{validationData.fee_id}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="paymentTerm" class="col-form-label">Payment Term <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.payment_terms_id" @blur="validationRule()" class="form-control" id="paymentTerm">
										<option value="">Select Payment Term</option>
										<option v-for="term in termList" :key="term.id" :value="term.id">{{ term.name }} - {{ term.payment_type.name }}</option>
									</select>
									<small class="text-danger">{{validationData.payment_terms_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="discount" class="col-form-label">Discount </label>
									<select v-model="enrollmentRequest.discount" @blur="validationRule()" @change="calculateDiscount()" class="form-control" id="discount">
										<option value="">Select Discount</option>
										<option v-for="discount in discountList" :key="discount.id" :value="discount.id">{{ discount.name }}</option>
									</select>
									<small class="text-danger">{{validationData.discount}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="parentName" class="col-form-label">Total Fees <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.total_fees" @blur="validationRule()" class="form-control" id="parentName">
									<small class="text-danger">{{validationData.total_fees}}</small>
								</div>
								<div class="col-md-6">
									<label for="discountAmount" class="col-form-label">Discount Amount</label>
									<input type="text" v-model="enrollmentRequest.discount_amount" readonly class="form-control" id="discountAmount">
									<small class="text-danger">{{validationData.discount_amount}}</small>
								</div>
							</div>
						</form>
						<button type="submit" @click="updateStatus('rejected')" class="btn btn-danger float-rejected">Rejected</button>

						<button type="submit" @click="updateStatus('approved')" class="btn btn-primary float-save">Approved</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'enrollmentAliasEdit',
		metaInfo: {
            title: "Enrollment Request Edit",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				batchCodeList: [],
				discountList: [],
				feeCodeList: [],
				termList: [],
				originalFeeAmount: 0,
				id: '',
				student_code: "",
				student_name: "",
				filter: {
					page: "",
					per_page: "",
					sort_direction: "",
					sort_by: "",
					search_batch: "",
					search_fee: "",
					search_student: "",
					status: "",
					date_from: "",
					date_to: "",
				},
				enrollmentRequest: {
					enrollment_id: "",
					discount: "",
					batch_id: "",
					fee_id: "",
					payment_terms_id: "",
					total_fees: "",
					discount_amount: 0,
				},
				validationData: {
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				aliasEnrollmentStatusAction: 'aliasEnrollmentStatusAction',
				enrollmentDetailAction: 'enrollmentDetailAction',
				getBatchCodeAction: 'getBatchCodeAction',
				getDiscountAction: 'getDiscountAction',
				getFeeCodeAction: 'getFeeCodeAction',
				getTermAction: 'getTermAction',
			}),
			async getEnrollmentDetail(){
				let option = {
					id: this.id,
					type: "alias"
				}
				await this.enrollmentDetailAction(option).then(async res => {
					this.enrollmentRequest.enrollment_id = res.data.enrollment_id
					this.student_code = res.data.student.student_code
					this.student_name = res.data.student.name
					this.enrollmentRequest.discount = res.data.discount_id || ""
					this.enrollmentRequest.batch_id = res.data.batch_id || ""
					this.enrollmentRequest.fee_id = res.data.fee_id || ""
					this.enrollmentRequest.payment_terms_id = res.data.payment_terms_id || ""
					this.enrollmentRequest.total_fees = res.data.amount || ""
					this.enrollmentRequest.discount_amount = res.data.discount_amount || 0
					
					console.log("Enrollment fee_id:", this.enrollmentRequest.fee_id)
					console.log("Response fee_id:", res.data.fee_id)
					
					// Store the original fee amount for discount calculations
					this.originalFeeAmount = this.enrollmentRequest.total_fees || 0;
					
					// Load fee codes for the selected batch
					if(this.enrollmentRequest.batch_id) {
						await this.loadFeeCodesByBatch();
					}
					
					// Load terms for the selected fee
					if(this.enrollmentRequest.fee_id) {
						await this.loadTermsByFee();
					}
					
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getDiscount(){
				await this.getDiscountAction().then(res => {
					this.discountList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getBatchCode(){
				await this.getBatchCodeAction().then(res => {
					this.batchCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getFeeCode(){
				// Reset fee selection when batch changes
				this.enrollmentRequest.fee_id = "";
				this.enrollmentRequest.total_fees = "";
				this.enrollmentRequest.discount_amount = 0;
				this.feeCodeList = [];
				this.termList = [];

				let option = {
					batch_id: this.enrollmentRequest.batch_id
				}
				await this.getFeeCodeAction(option).then(res => {
					this.feeCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async loadFeeCodesByBatch(){
				// Load fee codes without resetting values (for edit mode)
				let option = {
					batch_id: this.enrollmentRequest.batch_id
				}
				await this.getFeeCodeAction(option).then(res => {
					this.feeCodeList = res.data
					console.log("Fee codes loaded:", this.feeCodeList.length)
				}).catch(err => console.error("Error loading fee codes:", err))
			},
			async loadTermsByFee(){
				// Load terms without resetting values (for edit mode)
				let option = {
					fee_id: this.enrollmentRequest.fee_id
				}
				await this.getTermAction(option).then(res => {
					this.termList = res.data
					console.log("Terms loaded:", this.termList.length)
				}).catch(err => console.error("Error loading terms:", err))
			},
			async getTerm(){
				// Reset payment term when fee changes
				this.enrollmentRequest.payment_terms_id = "";
				
				// Get the selected fee amount and recalculate discount
				this.getFeeAmount();
				
				let option = {
					fee_id: this.enrollmentRequest.fee_id
				}
				await this.getTermAction(option).then(res => {
					this.termList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			getFeeAmount(){
				if(this.enrollmentRequest.fee_id && this.feeCodeList.length > 0) {
					const selectedFee = this.feeCodeList.find(fee => fee.id == this.enrollmentRequest.fee_id);
					if(selectedFee) {
						// Set the original fee amount
						const feeAmount = selectedFee.amount || selectedFee.fee_amount || 0;
						this.enrollmentRequest.total_fees = feeAmount;
						this.originalFeeAmount = feeAmount;
						
						// Recalculate discount if discount is already selected
						this.calculateDiscount();
					}
				} else {
					// No fee selected, reset amounts
					this.enrollmentRequest.total_fees = "";
					this.enrollmentRequest.discount_amount = 0;
				}
			},
			calculateDiscount(){
				const originalAmount = this.originalFeeAmount;
				console.log(this.enrollmentRequest.discount)
				if(this.enrollmentRequest.discount && this.discountList.length > 0 && this.enrollmentRequest.discount != "") {
					const selectedDiscount = this.discountList.find(discount => discount.id == this.enrollmentRequest.discount);
					if(selectedDiscount) {
						let discountAmount = 0;
						
						if(selectedDiscount.discount_type === 'percentage') {
							// Calculate percentage discount
							discountAmount = (originalAmount * selectedDiscount.discount_value) / 100;
						} else if(selectedDiscount.discount_type === 'fixed') {
							// Calculate fixed discount
							discountAmount = selectedDiscount.discount_value;
						}
						
						// Ensure discount doesn't exceed original amount
						if(discountAmount > originalAmount) {
							discountAmount = originalAmount;
						}
						
						this.enrollmentRequest.discount_amount = discountAmount;
						this.enrollmentRequest.total_fees = originalAmount - discountAmount;
					}
				} else {
					console.log("No discount selected")
					console.log(originalAmount)
					// No discount selected, reset to original amount
					this.enrollmentRequest.discount_amount = 0;
					this.enrollmentRequest.total_fees = this.originalFeeAmount;
				}
			},
			async updateStatus(status) {
				this.isLoading = true

				const formData = new FormData();
				formData.append('enrollment_id', this.enrollmentRequest.enrollment_id);
				formData.append('request_status', status);

				await this.aliasEnrollmentStatusAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: '/enrollment-list', 
					query: {
						page: this.filter.page, 
						per_page: 10,
						sort_direction: 'desc', 
						sort_by: 'created_at',
						search_batch: this.filter.search_batch,
						search_fee: this.filter.search_fee,
						search_student: this.filter.search_student,
						status: this.filter.status,
						date_from: this.filter.date_from,
						date_to: this.filter.date_to,
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			this.filter.page = this.$route.query.page
			this.filter.per_page = this.$route.query.per_page
			this.filter.sort_direction = this.$route.query.sort_direction
			this.filter.sort_by = this.$route.query.sort_by
			this.filter.search_batch = this.$route.query.search_batch || ''
			this.filter.search_fee = this.$route.query.search_fee || ''
			this.filter.search_student = this.$route.query.search_student || ''
			this.filter.status = this.$route.query.status || ''
			this.filter.date_from = this.$route.query.date_from || ''
			this.filter.date_to = this.$route.query.date_to || ''
			this.id = this.$route.query.id || ''
			
			// Load basic data first
			await this.getBatchCode()
			await this.getDiscount()
			
			// Then load enrollment details
			await this.getEnrollmentDetail()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>